import store from '@/storage/store';

const deviceList = () => {
  return store.getters.getDeviceList;
};

const numberFormat = (value) => {
  return `${Number(value).toFixed(3)}`;
};

const getStatus = (deviceMAC) => {
  try {
    const findDevice = deviceList()[
      deviceList().findIndex(e => e.mac == deviceMAC)
    ];

    if (
      findDevice.status == "ONLINE" &&
      findDevice.connection == "BT_MQTT"
    ) {
      return 1;
    } else {
      return 0;
    }
  } catch (err) {
    return 0;
  }
};

export {getStatus, numberFormat };